<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px; text-align: center"><b>PARTICIPAÇÃO NO CULTO INFANTIL</b></p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados do responsável:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" data-vv-name="cpf" type="tel" v-model="responsavel.cpf" @change="consultaCPF(responsavel.cpf)" append-outer-icon="search"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light disabled v-model="responsavel.nome" label="NOME" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field disabled light v-model="responsavel.telefone" label="TELEFONE" outlined color="#00695C" required dense hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-data-iterator
                        :items="iterador.conteudo"
                        :items-per-page.sync="iterador.itensPorPagina"
                        hide-default-footer
                        :loading="iterador.carregamento"
                        :key="x"
                      >
                        <template v-slot:header>
                          <!--  -->
                        </template>
                        <template v-slot:no-data>
                          <v-alert v-show="false" class="mt-5 mb-0" type="info" dense text>Nenhum profissional localizado para o serviço selecionado</v-alert>
                        </template>
                        <template v-slot:loading>
                          <v-progress-linear class="mt-5 mb-0" indeterminate color="primary"></v-progress-linear>
                          <p class="mt-2 mb-0" style="text-align: center">Carregando itens...</p>
                        </template>
                        <template v-slot:default="props">
                          <v-row v-for="(item) in props.items" :key="item.name" cols="12" xs="12" sm="12" md="4" lg="4">
                            <v-col cols="12">
                              <v-card outlined>
                                <v-card-title>Dados da criança:</v-card-title>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 lg5>
                                      <v-text-field light v-model="item.nome" label="NOME COMPLETO" outlined color="#00695C" dense hide-details required readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 lg5>
                                      <v-text-field light :value="item.celula ? item.celula.nome : 'Não informado'" label="CÉLULA" outlined color="#00695C" dense hide-details required readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 lg2>
                                      <v-text-field light :value="getIdadeFormatada(item.dataNascimento)" label="IDADE" outlined color="#00695C" dense hide-details required readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 lg12>
                                      <v-alert v-if="item.turmaInscrita" dense style="margin: 0px; text-align: center">
                                        <qrcode-vue :value="item.membroTurmaId" :size="160" level="H"></qrcode-vue>
                                        <p style="margin: 10px 0px 0px 0px">{{ item.turmaInscrita }}</p>
                                        <br>
                                        <v-btn small tile elevation="0" color="error" @click="cancelarPresenca(item)">Cancelar presença</v-btn>
                                      </v-alert>
                                      <v-btn v-else block elevation="0" color="success" @click="criarCadastro(calculaIdade(item.dataNascimento), item.id)">Confirmar presença</v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-iterator>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <a href="https://wa.me/5583999167480?text=Olá,%20preciso%20de%20ajuda%20no%20Templus" target="_blank">
                        <p style="margin-bottom: 0px; text-align: center">Dúvidas? Fale conosco!</p>
                      </a>
                      <router-link to="/liberdadeeb">
                        <p style="margin-bottom: 0px; text-align: center">Não encontrou a criança? Clique aqui para cadastrar.</p>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <!-- <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="criaMembro">Confirmar Cadastro</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>
              </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>
        <!-- FIM INSCRIÇÃO -->

        <!-- MENSAGEM FINAL -->
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>Informação</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <p class="texto" style="color:#00695C">Deseja matricular {{ membro.nome }} agora em Escola Bíblica Liberty?</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="criarInscricaoEvento">Sim</v-btn>
              <v-btn text color="primary" @click="closeDialog">Não</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM MENSAGEM FINAL -->

        <v-dialog v-model="dialogoCadastroEvento" persistent max-width="500px">
          <v-card>
            <v-card-title>Parabéns</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="texto" style="color:#00695C">Inscrição para Escola Bíblica Liberty realizada com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- INÍCIO MENSAGEM NÃO CADASTRADO -->
        <v-dialog v-model="dialogoMembroNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="texto" style="color: #666">O CPF informado não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a href="https://templus.intelite.com.br/liberdade">Clique aqui</a> e cadastre-se agora.<br><br>Após realizar o seu cadastro, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoMembroNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM MENSAGEM NÃO CADASTRADO -->

        <v-dialog v-model="dialogoCriancaNaoCadastrada" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="texto" style="color: #666">O CPF informado não possui crianças vinculadas na <strong>{{ igreja.nome }}</strong>. <a href="https://templus.intelite.com.br/liberdadeeb">Clique aqui</a> e vincule agora.<br><br>Após realizar o seu cadastro, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoCriancaNaoCadastrada = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import QrcodeVue from 'qrcode.vue'
export default {
  components: { Snackbar, Loading, QrcodeVue, },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
  }),
  data: function () {
    return {
      idIgreja: '6390de5538a3bc18300a2022',
      igreja: {},
      user: {},
      eventoSelecionado: '',
      membro: {
        nome: '',
        dataNascimento: '',
        sexo: '',
        celulaId: '',
        igrejaId: '',
        tipo: ''
      },
      responsavel: {
        nome: '',
        cpf: '',
        telefone: '',
        id: '',
      },
      informacoesBatismo: {
        batizado: null,
        igrejaBatismo: '',
        batismoLiberdade: null,
      },
      iterador: {
        carregamento: false,
        conteudo: [],
        itensPorPagina: -1,
        servicos: [],
      },
      dialog: false,
      dialogoMembroNaoCadastrado: false,
      dialogoCriancaNaoCadastrada: false,
      dialogoCadastroEvento: false,
      redeSelecionada: '',
      sexo: ['MASCULINO', 'FEMININO'],
      estadoCivil: ['SOLTEIRO(A)', 'CASADO(A)', 'VIÚVO(A)', 'DIVORCIADO(A)', 'RELAÇÃO ESTÁVEL'],
      tipoMembro: ['CONGREGADO', 'MEMBRO'],
      tipoIntegracao: ['ATRAVÉS DE BATISMO', 'VENHO DE OUTRA IGREJA'],
      condicoes: [
        { value: true, text: 'SIM'},
        { value: false, text: 'NÂO'},
      ],
      redes: [],
      celulas: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: '',
      msgResultado: '',
      codigoGerado: '',
      tipoFormulario: '',
      membroCarregado: [],
      membroId: '',
      x: 1,
      dictionary: {          
        custom: {
          dateOfBirth: {
            required: () => 'Informe a data de nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Insira um e-mail válido (apenas minúsculas)'
        },
      },
    }
  },
  
  mounted: function () {
    this.carregaDados()
  },
  
  watch: {
    'membro.batismoLiberdade'(val) {
      if (this.membro.batizado && val == true) { 
        this.membro.tipo = 'MEMBRO'
      } else {
        this.membro.tipo = 'CONGREGADO'
      }
    },

    'membro.batizado'(val) {
      if (val == false) {
        this.membro.tipo = 'CONGREGADO'
      }
    }
  },

  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
        if (response.data) {
          this.igreja = response.data
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
      } finally {
        this.isLoading = false
      }
    },

    async carregaRedes() {
      await axios.post(baseApiUrl + 'Redes/listarPublicasPorTipo', {
        igrejaId: this.igreja.id,
        tipo: 'KIDS',
      }).then(response => {
        if (response.data) {
          this.redes = response.data
        }
      })
    },

    async carregaCelulas() {
      await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } })
      .then(response => {
        if (response.data) {
          this.celulas = response.data
        }
      })
    },

    async consultaCPF(cpf) {
      // Limpa os dados anteriores
      this.iterador.conteudo = []
      this.responsavel.nome = ''
      this.responsavel.telefone = ''
      this.responsavel.id = ''
      
      this.isLoading = true
      
      try {
        const response = await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf } })
        
        if (response.data && response.data.id) {
          this.responsavel.nome = response.data.nome
          this.responsavel.telefone = response.data.telefone
          this.responsavel.id = response.data.id

          const result = await axios.post(baseApiUrl + 'Membros/listarDependentesPublico', null, {
            params: {
              responsavelId: response.data.id,
              tipo: response.data.sexo == 'MASCULINO' ? 'pai' : 'mae'
            }
          })
          
          if (result.data.length > 0) {
            // Normaliza os dados para garantir que todos os objetos necessários existam
            const dadosNormalizados = result.data.map(item => ({
              ...item,
              celula: item.celula || { nome: 'Não informado' },
              membroTurmaId: null,
              turmaInscrita: null
            }))
            
            // Força a reatividade do Vue
            this.$set(this.iterador, 'conteudo', dadosNormalizados)
            await this.consultaInscricaoTurmas()
          } else {
            this.dialogoCriancaNaoCadastrada = true
          }
        } else {
          this.dialogoMembroNaoCadastrado = true
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao consultar dados. Tente novamente.', 'ERRO')
      } finally {
        this.isLoading = false
      }
    },

    async criaMembro() {
      let responsavel
      if (this.responsavel.pai.cpf || this.responsavel.mae.cpf) {
        responsavel = 'PREENCHIDO'
      } else {
        responsavel = 'NÃO PREENCHIDO'
      }
      var vm = this;
      if (responsavel == 'NÃO PREENCHIDO' || !this.membro.nome || !this.membro.sexo || !this.membro.dataNascimento || !this.redeSelecionada || !this.membro.celulaId) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente!", "ATENÇÃO")
      } else {
        this.membro.tipo = 'CONGREGADO'
        this.membro.maeId = this.responsavel.mae.id
        this.membro.paiId = this.responsavel.pai.id
        this.isLoading = true
        this.membro.igrejaId = this.igreja.id
        await axios.post(baseApiUrl + 'Membros/salvarPublico', this.membro)
        .then(response => {
          if (response.data) {
            this.membroId = response.data.id
            this.dialog = true
            this.isLoading = false
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar cadastro. Verifique os dados informados e tente novamente", "DESCULPE")
        })
      }
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    closeDialog() {
      this.dialog = false
      this.vigilante = Object.assign({}, this.vigilanteDefault)
      this.$validator.reset()
      window.location.reload()
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async criarInscricaoEvento() {
      this.dialog = false
      this.isLoading = true
      let dados = {
        "nome": this.membro.nome,
        "sexo": this.membro.sexo,
        "eventoId": "63c6e81ce59b554a3da1d616",
        "membroId": this.membroId,
        "igrejaId": this.idIgreja,
        "whatsApp": this.responsavel.mae.telefone != '' ? this.responsavel.mae.telefone : this.responsavel.pai.telefone,
      }
      await axios.post(baseApiUrl + 'inscricoes/salvarPublica', {
        ...dados,
        cpf: this.membro.cpf
      })
      .then(response => {
        if (response.data) {
          this.isLoading = false
          this.dialogoCadastroEvento = true
        }
      })
    },

    calculaIdade(dataNasc) {
      try {
        if (!dataNasc) return 0;
        
        let dataAtual = new Date();
        let anoAtual = dataAtual.getFullYear();
        let anoNascParts = dataNasc.split('/');
        
        if (anoNascParts.length !== 3) return 0;
        
        let diaNasc = parseInt(anoNascParts[0]);
        let mesNasc = parseInt(anoNascParts[1]);
        let anoNasc = parseInt(anoNascParts[2]);
        
        if (isNaN(diaNasc) || isNaN(mesNasc) || isNaN(anoNasc)) return 0;
        
        let idade = anoAtual - anoNasc;
        let mesAtual = dataAtual.getMonth() + 1;
        
        // Caso mês atual for menor que o de nascimento, não fez aniversário ainda;
        if (mesAtual < mesNasc) {
          idade--;
        } else {
          // Estando no mês do nascimento, verifica o dia
          if (mesAtual == mesNasc) {
            if (new Date().getDate() < diaNasc ) {
              // Caso a data atual for menor que o dia de nascimento, ainda não fez aniversário
              idade--;
            }
          }
        }
        return idade;
      } catch (error) {
        return 0;
      }
    },

    getIdadeFormatada(dataNascimento) {
      if (!dataNascimento) return 'Não informado';
      
      const idade = this.calculaIdade(dataNascimento);
      if (idade === 0) return 'Não informado';
      
      return idade + (idade === 1 ? ' ano' : ' anos');
    },

    proximoDomingo() {
      let hoje = moment();
      let diasParaDomingo = 7 - hoje.weekday();

      if (hoje.weekday() == 0)
        return hoje.format('YYYY-MM-DD');
      else
        return hoje.add(diasParaDomingo, "days").format('YYYY-MM-DD');
    },

    async criarCadastro(idade, id) {
      var vm = this;
      this.isLoading = true
      await axios.post(baseApiUrl + 'MembrosTurmas/inscricao', {"idade": idade.toString(), "membroId": id, "igrejaId": this.igreja.id})
      .then(response => {
        if (response.data) {
          this.isLoading = false
          this.consultaInscricaoTurmas()
        }
      })
      .catch(error => {
        if (error.response.data.error.message == 'Turma não encontrada.') {
          vm.$refs.chamaSnackbar.snack("orange", "Turma não localizada para a faixa etária", "ATENÇÃO")
        } else {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao confirmar presença da criança. Tente novamente", "DESCULPE")
        }
      })
    },

    async consultaInscricaoTurmas() {
      try {
        const membroIds = (this.iterador.conteudo || []).map(i => i.id).filter(Boolean)
        if (membroIds.length === 0) return

        const response = await axios.post(baseApiUrl + 'MembrosTurmas/statusInscricaoPublica', {
          membroIds: membroIds,
          dataAula: this.proximoDomingo() + 'T00:00:00.000Z',
        })

        const lista = response.data || []
        const porMembro = new Map(lista.map(i => [i.membroId, i]))

        for (let i = 0; i < this.iterador.conteudo.length; i++) {
          const status = porMembro.get(this.iterador.conteudo[i].id)
          if (status) {
            this.iterador.conteudo[i].membroTurmaId = status.membroTurmaId
            const dataStr = status.dataAula ? status.dataAula.substring(0, 10) : this.proximoDomingo()
            if (this.iterador.conteudo[i].sexo == 'MASCULINO') {
              this.iterador.conteudo[i].turmaInscrita = 'Inscrito na turma ' + status.turmaNome + ' para o dia ' + this.formatDateBrz(dataStr) + '.'
            } else {
              this.iterador.conteudo[i].turmaInscrita = 'Inscrita na turma ' + status.turmaNome + ' para o dia ' + this.formatDateBrz(dataStr) + '.'
            }
          } else {
            this.iterador.conteudo[i].membroTurmaId = null
            this.iterador.conteudo[i].turmaInscrita = null
          }
        }

        this.x++
      } catch (e) {
        this.x++
      }
    },

    async cancelarPresenca(item) {
      var r = confirm('Deseja realmente cancelar a participação de ' + item.nome + ' no culto infantil?')
      if (r == true) {
        await axios.post(baseApiUrl + 'MembrosTurmas/cancelarPresencaPublica', {
          membroTurmaId: item.membroTurmaId,
          membroId: item.id,
        }).then(response => {
          if (response.data && response.data.count == 1) {
            this.consultaCPF(this.responsavel.cpf)
          }
        }).catch(() => {
          this.$refs.chamaSnackbar.snack("#EF5350", "Problema ao cancelar presença. Tente novamente.", "DESCULPE")
        })
      }
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #5BC1A3, #01B094);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
